var imageReader = require('./imageReader');

$('.js-image-input-file').change(function (event) {
  var $this = $(this);
  var file = this.files[0];
  if (!file) {
    return;
  }

  var $target = $($this.attr('data-preview-target'));
  if (!$target) {
    return;
  }

  return imageReader.readAsDataURL(file)
    .then(function (data) {
      $target.attr('src', data);
    });
});
